var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useClassNames } from '../../hooks/use-class-names';
import styles from './buttons.module.scss';
export var Button = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.cfg, globalStyles = _b === void 0 ? {} : _b, className = _a.className, _c = _a.appearance, appearance = _c === void 0 ? 'primary' : _c, _d = _a.intent, intent = _d === void 0 ? 'none' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, Before = _a.before, After = _a.after, disabled = _a.disabled, loading = _a.loading, testId = _a.testId, _f = _a.type, type = _f === void 0 ? 'button' : _f, props = __rest(_a, ["children", "cfg", "className", "appearance", "intent", "size", "before", "after", "disabled", "loading", "testId", "type"]);
    var classNames = useClassNames(globalStyles, [
        styles.button,
        styles["appearance-" + appearance],
        styles["intent-" + intent],
        styles["size-" + size],
        className,
    ]);
    return (React.createElement("button", __assign({ type: type, disabled: disabled || loading, className: classNames, "data-testid": testId, ref: ref }, props), loading ? ('Loading...') : (React.createElement(React.Fragment, null,
        Before && React.createElement(Before, null),
        children,
        After && React.createElement(After, null)))));
});
//# sourceMappingURL=buttons.js.map